export enum TemplateTabsKey {
  Build = "build",
  General = "general",
  Variables = "parámetros",
}
